export default __webpack_public_path__ + "static/media/chevron_left_black.d00cd45a.svg";